import { Tabs } from '@cloudscape-design/components';
import { templateRegistry } from '../templates/registry';

interface TypeFilterTabsProps {
  counts: Record<string, number>;
  total: number;
  selectedType: string | null;
  onTypeChange: (type: string | null) => void;
}

/**
 * Horizontal filter tabs above the configuration table.
 * One tab per configType with badge showing count.
 * "All" tab shows total count.
 *
 * Requirements: 7.1–7.12
 */
export function TypeFilterTabs({ counts, total, selectedType, onTypeChange }: TypeFilterTabsProps) {
  const tabs = [
    {
      id: 'all',
      label: `All (${total})`,
    },
    ...Array.from(templateRegistry.values()).map((template) => {
      const count = counts[template.configType] ?? 0;
      return {
        id: template.configType,
        label: `${template.displayName} (${count})`,
        disabled: count === 0,
      };
    }),
  ];

  return (
    <Tabs
      activeTabId={selectedType ?? 'all'}
      onChange={({ detail }) => {
        onTypeChange(detail.activeTabId === 'all' ? null : detail.activeTabId);
      }}
      tabs={tabs}
    />
  );
}
